import { withProps } from 'recompose'

import Testimonial from 'layouts/Testimonial'

import nameIconSrc from './brian_moseley.svg'
import faceIconSrc from './brian_moseley_face.png'

export default withProps({
  role: 'Partner Development Manager',
  nameIconSrc,
  faceIconSrc,
  quote: `
    Question for Salespeople: has your director of marketing booked any meetings on your calendar recently? Thanks to Drift for enabling marketers to literally book meetings for sales.
  `
})(Testimonial)



// WEBPACK FOOTER //
// ./src/layouts/MoseleyTestimonial/index.js